import { useState,useRef,useEffect } from "react";
import BaseInput from "../baseComponents/baseInput.js";


const Coder = ({
    stateSetter = () => {},
    onEnter = () => {},
    fullCodeStateSetter = () => {},
  }) => {
    const refMiniInput1 = useRef();
    const refMiniInput2 = useRef();
    const refMiniInput3 = useRef();
    const refMiniInput4 = useRef();
    const refMiniInput5 = useRef();
    const refMiniInput6 = useRef();
  
    const [codeDigit1, setCodeDigit1] = useState("");
    const [codeDigit2, setCodeDigit2] = useState("");
    const [codeDigit3, setCodeDigit3] = useState("");
    const [codeDigit4, setCodeDigit4] = useState("");
    const [codeDigit5, setCodeDigit5] = useState("");
    const [codeDigit6, setCodeDigit6] = useState("");
  
    const fullCode = `${codeDigit1}${codeDigit2}${codeDigit3}${codeDigit4}${codeDigit5}${codeDigit6}`;
    const fullCodeLength = fullCode.replaceAll(" ", "").length;
    const isFullCode = fullCodeLength === 6;
  
    useEffect(() => {
      stateSetter(fullCode);
      fullCodeStateSetter(isFullCode);
    }, [codeDigit1, codeDigit2, codeDigit3, codeDigit4, codeDigit5, codeDigit6]);
  
    const styles = {
      codeDiv: {
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-evenly",
      },
      oneDigit: {
        width: "2em",
        textAlign: "center",
        textTransform: "uppercase",
      },
    };
  
    const [inputsDisabled, setInputsDisabled] = useState(false);
  
    useEffect(() => {
      setTimeout(() => {
        try { refMiniInput1.current.focus()} catch(err) {}
       
      }, 100);
     
    }, []);
  
    const functionObjects = [
      { ref: refMiniInput1, stateSetter: setCodeDigit1 },
      { ref: refMiniInput2, stateSetter: setCodeDigit2 },
      { ref: refMiniInput3, stateSetter: setCodeDigit3 },
      { ref: refMiniInput4, stateSetter: setCodeDigit4 },
      { ref: refMiniInput5, stateSetter: setCodeDigit5 },
      { ref: refMiniInput6, stateSetter: setCodeDigit6 },
    ];
  
    const handleMiniInput = (e) => {
      const refId = e.target.id.split("miniInput")[1];
  
      const currentElement = functionObjects[refId - 1];
      const nextElement = functionObjects[refId];
      const prevElement = functionObjects[refId - 2];
  
      const isCharacterKeyOrBackspace =
        (e.keyCode >= 48 && e.keyCode <= 90) ||
        (e.keyCode >= 96 && e.keyCode <= 111) ||
        e.key === "Backspace" ||
        e.keyCode === 229;
      const isEneter = e.key === "Enter";
  
      if (e.type === "change") {
        currentElement.stateSetter(e.target.value.toUpperCase());
      } else if (e.type === "keydown") {
        setTimeout(() => {
          if (isCharacterKeyOrBackspace === true) {
            if (e.key !== "Backspace") {
              if (nextElement) {
                // setInputsDisabled(true);
                nextElement.ref.current.focus();
                nextElement.ref.current.select();
                // setInputsDisabled(false);
              }
            } else {
              if (prevElement) {
                setInputsDisabled(true);
                prevElement.ref.current.focus();
                prevElement.ref.current.select();
                setInputsDisabled(false);
              }
            }
          } else if (isEneter === true) {
            onEnter(fullCode, isFullCode);
          }
        }, 25);
      }
    };
  
    return (
      <div style={styles.codeDiv}>
        <BaseInput
          maxLength={1}
          onChange={(e) => {
            handleMiniInput(e);
          }}
          onKeyDown={(e) => {
            handleMiniInput(e);
          }}
          innerRef={refMiniInput1}
          style={styles.oneDigit}
          type="text"
          id="miniInput1"
          disabled={inputsDisabled}
        />
        <BaseInput
          maxLength={1}
          onChange={(e) => {
            handleMiniInput(e);
          }}
          onKeyDown={(e) => {
            handleMiniInput(e);
          }}
          innerRef={refMiniInput2}
          style={styles.oneDigit}
          type="text"
          id="miniInput2"
          disabled={inputsDisabled}
        />
        <BaseInput
          maxLength={1}
          onChange={(e) => {
            handleMiniInput(e);
          }}
          onKeyDown={(e) => {
            handleMiniInput(e);
          }}
          innerRef={refMiniInput3}
          style={styles.oneDigit}
          type="text"
          id="miniInput3"
          disabled={inputsDisabled}
        />
        <BaseInput
          maxLength={1}
          onChange={(e) => {
            handleMiniInput(e);
          }}
          onKeyDown={(e) => {
            handleMiniInput(e);
          }}
          innerRef={refMiniInput4}
          style={styles.oneDigit}
          type="text"
          id="miniInput4"
          disabled={inputsDisabled}
        />
        <BaseInput
          maxLength={1}
          onChange={(e) => {
            handleMiniInput(e);
          }}
          onKeyDown={(e) => {
            handleMiniInput(e);
          }}
          innerRef={refMiniInput5}
          style={styles.oneDigit}
          type="text"
          id="miniInput5"
          disabled={inputsDisabled}
        />
        <BaseInput
          maxLength={1}
          onChange={(e) => {
            handleMiniInput(e);
          }}
          onKeyDown={(e) => {
            handleMiniInput(e);
          }}
          innerRef={refMiniInput6}
          style={styles.oneDigit}
          type="text"
          id="miniInput6"
          disabled={inputsDisabled}
        />
      </div>
    );
  };
  
  export default Coder;
  